module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-152.4cbcf54.woff2";